import { render, staticRenderFns } from "./TextAndImage.vue?vue&type=template&id=146a8458"
import script from "./TextAndImage.vue?vue&type=script&lang=js"
export * from "./TextAndImage.vue?vue&type=script&lang=js"
import style0 from "./TextAndImage.vue?vue&type=style&index=0&id=146a8458&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports